import axios from "axios"

export const populateNavbarData = async () => {
    return axios.get('api/NavBar/Get')
}
